import React, { useRef, useEffect, useState, useCallback } from "react";
import { TextField } from "@material-ui/core";
import styled from "styled-components";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import apiErrorMessage from "../util/apiErrorMessage";

const FranchiseSearch = () => {
  const unmounted = useRef(false);

  const [searchQuery, setSearchQuery] = useState("");
  const searchQueryDebounceTimeoutRef = useRef(null);
  const [characters, setCharacters] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [totalIGFollowerCount, setTotalIGFollowerCount] = useState(0);

  const SendSearch = useCallback(async (searchQuery) => {
    if (!searchQuery) return;
    setIsSearching(true);
    setErrorText("");
    setCharacters([]);
    setTotalIGFollowerCount(0);
    try {
      const data = await axios.get(
        `/api/franchise/search?q=${encodeURIComponent(
          searchQuery
            .replaceAll(".", "")
            .replaceAll("'", "")
            .replaceAll(" ", "")
            .replaceAll("-", ""),
        )}`,
      );
      if (unmounted.current) return;
      const characters = data.data;
      // if (characters.length > 10) characters.length = 10;
      setCharacters(characters);
    } catch (error) {
      console.error(error);
      setErrorText(
        apiErrorMessage(error, "Something went wrong. Please try again."),
      );
    } finally {
      setIsSearching(false);
    }
  }, []);

  useEffect(() => {
    return () => {
      unmounted.current = true;
      clearInterval(searchQueryDebounceTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    clearInterval(searchQueryDebounceTimeoutRef.current);
    searchQueryDebounceTimeoutRef.current = setTimeout(() => {
      SendSearch(searchQuery);
    }, 1000);
    setErrorText("");
  }, [searchQuery, SendSearch]);

  useEffect(() => {
    let totalIGFollowerCounter = 0;
    for (const character of characters) {
      if (
        character?.person?.IGFollowerCount &&
        character?.person?.IGFollowerCount > 0
      ) {
        totalIGFollowerCounter += character.person.IGFollowerCount;
      }
    }
    setTotalIGFollowerCount(totalIGFollowerCounter);
  }, [characters]);

  return (
    <Container>
      <Title>Franchise Search</Title>
      <TextField
        disabled={isSearching}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {Boolean(errorText) && <ErrorText>{errorText}</ErrorText>}
      {Boolean(isSearching) && (
        <LoadingIndicator>
          <CircularProgress
            style={{ color: "inherit", width: "100%", height: "100%" }}
          />
        </LoadingIndicator>
      )}
      {characters.length > 0 && (
        <TotalSocialMediaStatsContainer>
          <b>Total IG Followers</b>: {totalIGFollowerCount}
        </TotalSocialMediaStatsContainer>
      )}
      <ResultsContainer>
        {characters.map((character) => (
          <CharacterResult key={`character_${character.unique_character_id}`}>
            <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
              {character.name}
            </div>
            <VoicedByText>
              Voiced By:{" "}
              {Boolean(character.person.avatar_url) && (
                <CharacterSignerAvatar src={character.person.avatar_url} />
              )}{" "}
              {character?.person?.name || "N/A"}
            </VoicedByText>
            {/* {Boolean(character.person.avatar_url) && <CharacterSignerAvatar src={character.person.avatar_url} />} */}
            {Boolean(character.person.instagram_handle) && (
              <SocialsContainer>
                <div style={{ fontWeight: "bold" }}>
                  @{character.person.instagram_handle}
                </div>
                <div>IG Followers: {character.person.IGFollowerCount}</div>
              </SocialsContainer>
            )}
          </CharacterResult>
        ))}
      </ResultsContainer>
    </Container>
  );
};

export default FranchiseSearch;

const Container = styled.div`
  padding: 20px;
  min-height: 90vh;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
`;

const ErrorText = styled.div`
  color: rgb(255, 70, 70);
  margin: 10px 0;
`;

const LoadingIndicator = styled.div`
  margin: 20px;
  margin-left: 10px;
  width: 34px;
  height: 34px;
  color: rgb(100, 100, 100);
`;

const ResultsContainer = styled.div``;

const CharacterResult = styled.div`
  border: 1px solid rgb(200, 200, 200);
  border-radius: 5px;
  padding: 8px;
  margin: 10px 0;
  color: rgb(30, 30, 30);
`;

const CharacterSignerAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgb(150, 150, 150);
  margin-left: 10px;
  margin-right: 5px;
`;

const VoicedByText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SocialsContainer = styled.div`
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 8px;
  display: inline-block;
  margin: 5px;
  margin-top: 10px;
`;

const TotalSocialMediaStatsContainer = styled.div`
  margin: 20px 0;
`;
